import { render } from "./index.vue?vue&type=template&id=772b0012&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=772b0012&lang=scss&scoped=true"

import exportComponent from "../../../../../.yarn/__virtual__/vue-loader-virtual-0d226ce3ab/0/cache/vue-loader-npm-17.4.2-00674d01e5-88760fe6a5.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772b0012"]])

export default __exports__